import { api_DELETE, api_GET, api_POST, api_PUT } from "./_api.js";

const requerimentoPodas_api = {
    getList: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`RequerimentoPodas/GetList/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    update: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`RequerimentoPodas/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default requerimentoPodas_api;
